import Reveal from "./Reveal";

const stores = [
  { icon: "ri-smartphone-line", title: "iOS 客户端", sub: "App Store 下载" },
  { icon: "ri-android-line", title: "Android 客户端", sub: "应用商店下载" },
];

export default function DownloadCta() {
  return (
    <section id="download" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <div className="overflow-hidden rounded-lg border border-foreground-800 bg-foreground-950">
            <div className="grid grid-cols-1 items-center gap-8 p-6 md:p-10 lg:grid-cols-[1.3fr_0.7fr] lg:gap-12">
              <div>
                <span className="font-label text-xs tracking-[0.35em] text-accent-400">DOWNLOAD</span>
                <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">
                  长图库入口 · 下载后离线慢读
                </h2>
                <p className="mt-4 max-w-xl font-body text-sm leading-relaxed text-background-300">
                  客户端支持整张长图无缝滑动、时间线一键定位与对照双开。适合想一次看完前因后果、慢慢对比细节的读者。
                </p>

                <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                  {stores.map((store) => (
                    <a
                      key={store.title}
                      href="#top"
                      className="flex cursor-pointer items-center gap-3 whitespace-nowrap rounded-md border border-background-700 bg-foreground-900 px-5 py-3 transition-colors hover:border-accent-500"
                    >
                      <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                        <i className={`${store.icon} text-xl`} />
                      </span>
                      <span className="flex flex-col">
                        <span className="font-label text-sm font-medium text-background-50">
                          {store.title}
                        </span>
                        <span className="font-label text-[11px] text-background-400">{store.sub}</span>
                      </span>
                    </a>
                  ))}
                </div>
              </div>

              <div className="flex flex-col items-center gap-3 rounded-lg border border-background-800 bg-foreground-900 p-6">
                <div className="flex h-36 w-36 items-center justify-center rounded-md bg-background-50">
                  <i className="ri-qr-code-line text-7xl text-foreground-900" />
                </div>
                <p className="font-label text-xs text-background-400">扫码进入长图库</p>
                <span className="rounded-full bg-primary-500 px-3 py-1 font-label text-[11px] text-background-50">
                  无需注册即可浏览
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}